import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import * as React from "react";

const EMSAddToList: React.FC<IconPresentationProps> = props => {
    return (
        <svg 
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="512"
            height="512"
            viewBox="0 0 24 24"
            fill="currentColor"
        >
        
        <path d="m19 20a1 1 0 0 1 -1-1v-4a1 1 0 0 1 2 0v4a1 1 0 0 1 -1 1z" />
      <path d="m21 18h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z" />
      <path d="m18 6h-15a1 1 0 0 1 0-2h15a1 1 0 0 1 0 2z" />
      <path d="m18 12h-15a1 1 0 0 1 0-2h15a1 1 0 0 1 0 2z" />
      <path d="m13 18h-10a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2z" />
            
        </svg>
    );
};

export default EMSAddToList;
